/**
 * Deficiency PDP below-fold — tabs + recommendations scroller.
 * Instant Brands interaction pattern; Feminine Balance markup (fb-def-*).
 */
(function () {
  "use strict";

  document.querySelectorAll("[data-fb-detail-tabs]").forEach(function (root) {
    if (root.dataset.tabsInit === "true") return;
    root.dataset.tabsInit = "true";

    var tabs = root.querySelectorAll("[data-fb-tab]");
    var panels = root.querySelectorAll("[data-fb-panel]");
    if (!tabs.length) return;

    function activate(index) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle("--active", on);
        tab.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle("--active", on);
        if (on) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activate(Number(tab.getAttribute("data-fb-tab") || 0));
      });
    });
  });

  document.querySelectorAll("[data-fb-recs]").forEach(function (root) {
    initHorizontalScroller(root, "[data-fb-recs-track]", "[data-fb-recs-prev]", "[data-fb-recs-next]", ".fb-def-recs__card", ".fb-def-recs__nav");
  });

  document.querySelectorAll("[data-fb-pairs]").forEach(function (root) {
    initHorizontalScroller(root, "[data-fb-pairs-track]", "[data-fb-pairs-prev]", "[data-fb-pairs-next]", ".fb-def-pairs__card", ".fb-def-pairs__nav");
  });

  function initHorizontalScroller(root, trackSel, prevSel, nextSel, cardSel, navSel) {
    if (root.dataset.scrollerInit === "true") return;
    root.dataset.scrollerInit = "true";

    var track = root.querySelector(trackSel);
    var prev = root.querySelector(prevSel);
    var next = root.querySelector(nextSel);
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector(cardSel);
      if (!card) return track.clientWidth * 0.82;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var nav = root.querySelector(navSel);
      if (!nav) return;
      var isCarousel = window.matchMedia("(max-width: 767px)").matches;
      nav.hidden = !isCarousel || track.scrollWidth <= track.clientWidth + 2;
    }

    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
    track.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    updateArrows();
  }
})();
